module.exports = __webpack_public_path__ + "img/3_70.afe4c828.png";